module.exports = __webpack_public_path__ + "media/images/logo/jgz-b114d8e733433a5f17825989fc39aef8.png";